/**
 * GlobalLoaderBrackets — variante 3 du loader global : chevrons `<` / `>`
 * qui s'écartent de part et d'autre du wordmark ALT/, façon balise
 * autofermante (cf. wordmark `<Alt/>` de `AltLogo`).
 *
 * @remarks
 * - Même pilotage que `GlobalLoader` (`useGlobalLoaderVisible`) et même voile
 *   (`GlobalLoaderOverlay`) — seul le visuel change.
 * - Un seul `<` et un seul `>` dans le DOM — pas une grappe. L'illusion de
 *   traîne (`<<<<<`) vient du mouvement (`chevronDriftLeft`/`Right` dans
 *   `globals.css`) combiné à un `text-shadow` qui pose des copies de plus en
 *   plus transparentes derrière chaque chevron : le déplacement fait le
 *   travail, pas la répétition du caractère.
 * - Couleurs façon wordmark réel (encre + accent) : `ALT` passe en `text-fg`
 *   (noir en clair, clair en sombre — suit le thème comme `AltLogo` inverse
 *   son encre) ; le `/` reste `text-brand`. Les chevrons, eux, sont en
 *   `text-brand-light` (tête plus claire) tandis que leur traîne reste
 *   `--color-brand` — un bicolore tête/traîne plutôt qu'un simple fondu.
 * - La traîne va jusqu'à 1.5em de la tête (`chevronChaseLeft`/`Right` dans
 *   `globals.css`), soit 2.25rem au `text-2xl` courant : l'espace entre
 *   chevron et `ALT` (`gap-11`, 2.75rem) doit rester strictement supérieur à
 *   cette portée, sinon la traîne empiète physiquement sur `ALT` — un souci
 *   de place, pas d'empilement. La portée étant en `em`, elle suit la taille
 *   du texte alors que le `gap` est en `rem` : toucher à l'un sans rejouer
 *   l'autre recrée le bug.
 */

import { GlobalLoaderOverlay } from './GlobalLoader';
import { useIsVeiled } from '@/shared/ui/loader-veil-context';

export function GlobalLoaderBrackets() {
  const visible = useIsVeiled();
  if (!visible) return null;

  return (
    <GlobalLoaderOverlay>
      <div
        aria-hidden
        className="global-loader-brackets font-display flex items-center gap-11 text-2xl font-bold tracking-tight select-none motion-reduce:[&_*]:animate-none"
      >
        <span className="glb-chevron-left text-brand-light">&lt;</span>
        <span>
          <span className="text-fg">ALT</span>
          <span className="text-brand">/</span>
        </span>
        <span className="glb-chevron-right text-brand-light">&gt;</span>
      </div>
    </GlobalLoaderOverlay>
  );
}
